import { DualPrice, Price, SinglePrice, formatPrice } from 'modules/proposals';
import React from 'react';

interface Props {
  currency: string;
  amount: number;
  exchangeRate?: number;
  dualCurrency?: string;
  ISOCountry?: string;
}

export const SubtotalIncludingDiscountsPrice: React.FC<Props> = ({
  currency,
  amount,
  exchangeRate,
  dualCurrency = 'eur',
  ISOCountry,
}) => (
  <Price
    currency={currency}
    dualCurrency={dualCurrency}
    customExchangeRate={exchangeRate}
    dualPriceElement={
      <DualPrice>
        <p className="t-eta">{formatPrice(amount, currency, ISOCountry)}</p>
        {exchangeRate && (
          <p className="o60 text--xxs__responsive">
            {formatPrice(amount * exchangeRate, dualCurrency, ISOCountry)}
          </p>
        )}
      </DualPrice>
    }
    singlePriceElement={
      <SinglePrice className="t-eta">
        {formatPrice(amount, currency, ISOCountry)}
      </SinglePrice>
    }
  />
);
